/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTreatmentQueueModel } from '../../models/patient-treatment-queue-model';

export interface PatientTreatmentQueuePatientTreatmentQueuePost$Params {
      body?: PatientTreatmentQueueModel
}

export function patientTreatmentQueuePatientTreatmentQueuePost(http: HttpClient, rootUrl: string, params?: PatientTreatmentQueuePatientTreatmentQueuePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patientTreatmentQueuePatientTreatmentQueuePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

patientTreatmentQueuePatientTreatmentQueuePost.PATH = '/PatientTreatmentQueue/PatientTreatmentQueue';
